import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { getExtStyles } from './getExtStyles';

type ImageContainerProps = {
  borderRadius?: number;
  processing?: boolean;
  ext?: string;
  color?: 'gray' | 'color' | 'default';
} & ComponentProps<'div'>;

export const ImageContainer = memo(
  ({ className, style, borderRadius, processing, ext, color, ...props }: ImageContainerProps) => (
    <div
      className={cn(
        'relative flex h-full grow flex-col items-center justify-center overflow-hidden',
        processing && 'shimmer-background',
        className,
      )}
      style={{
        backgroundColor: color === 'default' || !ext ? 'var(--colors-grey4)' : getExtStyles(ext).bgColor,
        borderRadius,
        ...style,
      }}
      {...props}
    />
  ),
);

ImageContainer.displayName = 'ImageContainer';
